import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Select } from 'core/components';

const valueRenderer = (option) => option?.label || null;

@observer
class GroupByControl extends Component {
  static defaultProps = {
    options: [[{ label: 'None', value: '' }]]
  };

  state = {
    grouping: ''
  };

  componentDidMount() {
    this.setInitialState();
  }

  setInitialState() {
    const { collection } = this.props;
    const grouping = collection.groupBy || '';

    this.handleGroupByChange(grouping);
  }

  handleGroupByChange = (grouping) => {
    this.setState({ grouping });

    setTimeout(() => {
      const { collection } = this.props;
      collection.group(grouping || null);
    }, 0);
  };

  // Only user picks are reported, not the initial sync on mount.
  handleSelectChange = (grouping) => {
    const { onChange } = this.props;
    this.handleGroupByChange(grouping);
    if (onChange) {
      onChange(grouping);
    }
  };

  render() {
    const { collection, options, onChange, ...selectProps } = this.props;
    const { grouping } = this.state;

    return (
      <Select
        inlineLabel
        label="Group By"
        menuWidth={180}
        onChange={this.handleSelectChange}
        options={options}
        small
        values={grouping}
        valueRenderer={valueRenderer}
        {...selectProps}
      />
    );
  }
}

export default GroupByControl;
